import { createPersistedStore, storage } from '@connect-x-app/hybrid-utils';
import { AuthenticatedUser } from '@connect-x-app/shared-domain-models';
import { createSerializableStorage } from '@connect-x-app/shared-utils';

type AuthenticationState = {
  setUser: (authenticatedUser: AuthenticatedUser | null) => void;
  user: AuthenticatedUser | null;
};

export const useAuthenticationStore = createPersistedStore<AuthenticationState>(
  (set, _) => ({
    setUser: user => {
      set({ user });
    },
    user: null,
  }),
  {
    name: 'authentication-store',
    storage: createSerializableStorage(storage),
  },
);
